/**
 * Campanha de cupom via URL (?cupom=CODIGO-30&cupom_colecao=handle)
 * Persistencia em sessionStorage por aba.
 */
(function () {
  const STORAGE_CUPOM = 'pozze_cupom';
  const STORAGE_COLECAO = 'pozze_cupom_colecao';

  function parseCupom(raw) {
    if (!raw || typeof raw !== 'string') return null;
    const trimmed = raw.trim();
    if (!trimmed) return null;

    const parts = trimmed.split('-');
    if (parts.length < 2) {
      return { code: trimmed, discountValue: 0, discountType: 'percent', cupom: trimmed };
    }

    const last = parts[parts.length - 1].trim();
    const discountValue = Number(last);
    if (last === '' || Number.isNaN(discountValue) || String(discountValue) !== last) {
      return { code: trimmed, discountValue: 0, discountType: 'percent', cupom: trimmed };
    }

    const code = parts.slice(0, -1).join('-').trim();
    if (!code || discountValue <= 0) return null;

    return {
      code,
      discountValue,
      discountType: 'percent',
      cupom: trimmed,
    };
  }

  function readUrlParams(collectionHandleFallback) {
    const params = new URLSearchParams(window.location.search);
    const cupom = params.get('cupom');
    if (!cupom) return null;

    let colecao = params.get('cupom_colecao');
    if (!colecao && collectionHandleFallback) {
      colecao = collectionHandleFallback;
    }
    if (!colecao) return null;

    const parsed = parseCupom(cupom);
    if (!parsed || !parsed.code || parsed.discountValue <= 0) return null;

    return {
      cupom: parsed.cupom,
      colecao: colecao.trim(),
      code: parsed.code,
      discountValue: parsed.discountValue,
      discountType: parsed.discountType,
    };
  }

  function persistFromUrl(collectionHandleFallback) {
    const active = readUrlParams(collectionHandleFallback);
    if (!active) return null;
    try {
      sessionStorage.setItem(STORAGE_CUPOM, active.cupom);
      sessionStorage.setItem(STORAGE_COLECAO, active.colecao);
    } catch (e) {
      console.warn('Pozze cupom: sessionStorage indisponivel', e);
    }
    return active;
  }

  function getActive(collectionHandleFallback) {
    const fromUrl = readUrlParams(collectionHandleFallback);
    if (fromUrl) return fromUrl;

    try {
      const cupom = sessionStorage.getItem(STORAGE_CUPOM);
      const colecao = sessionStorage.getItem(STORAGE_COLECAO);
      if (!cupom || !colecao) return null;
      const parsed = parseCupom(cupom);
      if (!parsed || !parsed.code || parsed.discountValue <= 0) return null;
      return {
        cupom,
        colecao: colecao.trim(),
        code: parsed.code,
        discountValue: parsed.discountValue,
        discountType: parsed.discountType,
      };
    } catch (e) {
      return null;
    }
  }

  function isProductEligible(productCollectionHandles, colecaoHandle) {
    if (!colecaoHandle || !Array.isArray(productCollectionHandles)) return false;
    const scope = String(colecaoHandle).trim().toLowerCase();
    return productCollectionHandles.some((h) => String(h).trim().toLowerCase() === scope);
  }

  function appendToProductUrl(baseUrl, active) {
    if (!active || !baseUrl) return baseUrl;
    try {
      const url = new URL(baseUrl, window.location.origin);
      url.searchParams.set('cupom', active.cupom);
      url.searchParams.set('cupom_colecao', active.colecao);
      return url.pathname + url.search;
    } catch (e) {
      const sep = baseUrl.indexOf('?') >= 0 ? '&' : '?';
      return (
        baseUrl +
        sep +
        'cupom=' +
        encodeURIComponent(active.cupom) +
        '&cupom_colecao=' +
        encodeURIComponent(active.colecao)
      );
    }
  }

  function formatMoney(cents, format, moneyFormat) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format || moneyFormat);
    }
    const value = (cents / 100).toFixed(2).replace('.', ',');
    return 'R$ ' + value;
  }

  function hydrateCardBadges() {
    const nodes = document.querySelectorAll('[data-pz-card-coupon]');
    if (!nodes.length) return;

    const pageCollection =
      document.documentElement.getAttribute('data-pozze-collection-handle') || '';
    const active = getActive(pageCollection || null);

    nodes.forEach((node) => {
      if (!active || !active.code || !active.colecao) {
        node.hidden = true;
        return;
      }

      const sameCollection =
        pageCollection && pageCollection.toLowerCase() === String(active.colecao).toLowerCase();
      if (!sameCollection) {
        node.hidden = true;
        return;
      }

      const basePrice = Number(node.getAttribute('data-price')) || 0;
      if (basePrice <= 0) {
        node.hidden = true;
        return;
      }

      const percent = Math.min(100, Math.max(0, Number(active.discountValue) || 0));
      const discountAmount = Math.round((basePrice * percent) / 100);
      const couponPrice = Math.max(0, basePrice - discountAmount);
      if (couponPrice >= basePrice) {
        node.hidden = true;
        return;
      }

      const priceEl = node.querySelector('.pz-card-coupon__price');
      const codeEl = node.querySelector('.pz-card-coupon__code');
      if (priceEl) priceEl.textContent = formatMoney(couponPrice);
      if (codeEl) codeEl.textContent = active.code;
      node.hidden = false;
    });
  }

  function registerAlpineStore() {
    if (typeof Alpine === 'undefined') return;

    Alpine.store('pozzeCoupon', {
      showBlock: false,
      apply: false,
      code: '',
      discountValue: 0,
      discountType: 'percent',
      colecao: '',
      cupom: '',
      couponPriceCents: 0,
      formattedCouponPrice: '',
      formattedReferencePrice: '',

      init(config) {
        if (!config) return;
        const handles = config.collectionHandles || [];
        const autoMode = Boolean(config.autoMode);

        const moneyFormat = config.moneyFormat || undefined;

        if (!autoMode) {
          this.showBlock = true;
          this.apply = Boolean(config.apply);
          this.code = config.code || '';
          this.discountValue = Number(config.discountValue) || 0;
          this.discountType = config.discountType || 'percent';
          this.couponPriceCents = Number(config.couponPriceCents) || 0;
          this.formattedCouponPrice = formatMoney(this.couponPriceCents, null, moneyFormat);
          if (config.referencePriceCents > 0) {
            this.formattedReferencePrice = formatMoney(config.referencePriceCents, null, moneyFormat);
          }
          return;
        }

        const active = getActive(config.collectionHandleFallback || null);
        if (!active || !isProductEligible(handles, active.colecao)) {
          this.showBlock = false;
          this.apply = false;
          this.code = '';
          this.formattedCouponPrice = '';
          this.formattedReferencePrice = '';
          return;
        }

        const basePrice = Number(config.basePriceCents) || 0;
        let discountAmount = 0;
        if (active.discountType === 'fixed') {
          discountAmount = Math.round(active.discountValue * 100);
        } else {
          const percent = Math.min(100, Math.max(0, active.discountValue));
          discountAmount = Math.round((basePrice * percent) / 100);
        }
        const couponPrice = Math.max(0, basePrice - discountAmount);

        this.showBlock = true;
        this.apply = Boolean(config.apply);
        this.code = active.code;
        this.discountValue = active.discountValue;
        this.discountType = active.discountType;
        this.colecao = active.colecao;
        this.cupom = active.cupom;
        this.couponPriceCents = couponPrice;
        this.formattedCouponPrice = formatMoney(couponPrice, null, moneyFormat);
        if (config.referencePriceCents > 0) {
          this.formattedReferencePrice = formatMoney(config.referencePriceCents, null, moneyFormat);
        }
      },
    });
  }

  window.PozzeCouponCampaign = {
    STORAGE_CUPOM,
    STORAGE_COLECAO,
    parseCupom,
    persistFromUrl,
    getActive,
    isProductEligible,
    appendToProductUrl,
    formatMoney,
    hydrateCardBadges,
  };

  document.addEventListener('DOMContentLoaded', () => {
    const fallback =
      document.documentElement.getAttribute('data-pozze-collection-handle') || '';
    persistFromUrl(fallback || null);
    hydrateCardBadges();
  });

  document.addEventListener('alpine:init', registerAlpineStore);
  if (window.Alpine) registerAlpineStore();

  /** Expõe init para a PDP chamar após o config Liquid estar disponível */
  window.PozzeCouponCampaign.initStore = function (config) {
    registerAlpineStore();
    if (typeof Alpine === 'undefined' || !Alpine.store('pozzeCoupon')) {
      document.addEventListener(
        'alpine:init',
        () => {
          registerAlpineStore();
          Alpine.store('pozzeCoupon')?.init(config);
        },
        { once: true }
      );
      return false;
    }
    Alpine.store('pozzeCoupon').init(config);
    return true;
  };
})();
